import React, { memo } from 'react';
export var PreloadIcon = /*#__PURE__*/memo(function (_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    height: "5",
    viewBox: "0 0 15 5",
    width: "15",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: color,
    height: "4",
    opacity: "0.6",
    rx: "1",
    width: "2",
    y: "0.5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: color,
    height: "4",
    opacity: "0.6",
    rx: "1",
    width: "2",
    x: "4",
    y: "0.5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: color,
    height: "4",
    opacity: "0.6",
    rx: "1",
    width: "2",
    x: "8",
    y: "0.5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: color,
    height: "4",
    opacity: "0.6",
    rx: "1",
    width: "2",
    x: "12",
    y: "0.5"
  }));
});